// Contexto para controlar animaciones específicas, como la de inicio

import React, { createContext, useContext, useState, useRef, useEffect, useCallback } from 'react';

const AnimationContext = createContext(null); // Inicializar con null es una buena práctica

export const AnimationProvider = ({ children }) => {
  const [showInitialAnimation, setShowInitialAnimation] = useState(false);
  // ✅ FIX: Track timeout for cleanup to prevent setState after unmount
  const animationTimeoutRef = useRef(null);

  // ✅ FIX: Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
    };
  }, []);

  // ✅ FIX: Wrap in useCallback and use ref for timeout tracking
  const triggerInitialAnimation = useCallback(() => {
    setShowInitialAnimation(true);
    // Clear any existing timeout
    if (animationTimeoutRef.current) {
      clearTimeout(animationTimeoutRef.current);
    }
    // Resetear el estado después de la animación
    animationTimeoutRef.current = setTimeout(() => {
      setShowInitialAnimation(false);
      animationTimeoutRef.current = null;
    }, 2000); // Duración de la animación (ajustar si es necesario)
  }, []);

  // Memoizar el valor para evitar re-renders innecesarios
  const value = React.useMemo(() => ({
    showInitialAnimation,
    triggerInitialAnimation
  }), [showInitialAnimation, triggerInitialAnimation]);

  return (
    <AnimationContext.Provider value={value}>
      {children}
    </AnimationContext.Provider>
  );
};

// Hook personalizado con nuevo nombre
export const useAnimation = () => { 
  const context = useContext(AnimationContext);
  if (context === undefined || context === null) { // Comprobar undefined o null
    throw new Error('useAnimation debe ser usado dentro de un AnimationProvider');
  }
  return context;
}; 